module.exports = __webpack_public_path__ + "static/balance-logo-5bf432f2f068a3765a226bfd07dd45f0.jpg";